import React, { useContext } from 'react'

import styled from 'styled-components'
import Slider from 'react-slick'
import { navigate } from 'gatsby'

import ContainerLayout from '../ui/containerLayout'
import Button from '../ui/buttons'

import { LocaleContext, useI18n } from '../../../locale.js'
import gamesArray from './data.js'
import '../ui/sliderStyles.css'

import fallingStar from '../../assets/images/elements/fallingStar.svg'
import slashedGreyCubes from '../../assets/images/elements/slashedGreyCubes.svg'
import activePlayer from '../../assets/icons/activePlayer.svg'
import unactivePlayer from '../../assets/icons/unactivePlayer.svg'
import { I18nextContext } from 'gatsby-plugin-react-i18next'

const Games = ({ city, isBirthday = false }) => {
  const { locale } = useContext(LocaleContext)
  const context = React.useContext(I18nextContext);

  const settings = {
    infinite: true,
    speed: 500,
    touchThreshold: 100,
    slidesToShow: 5.5,
    slidesToScroll: 1,
    //  swipeToSlide: true,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 2000,
    focusOnSelect: true,
    centerMode: true,
    arrows: false,
    dots: true,
    lazyLoad: true,

    customPaging: function (i) {
      return <span />
    },

    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 4.5
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.5
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const fullGameListText = useI18n('main.games.fullGameList')

  return (
    <ContainerLayoutStyled fullWidth id='games'>
      <TitleStyled>
        {useI18n('main.games.title')} <br />
        <b>{useI18n('main.games.play')}</b>
      </TitleStyled>

      <Slider {...settings}>
        {gamesArray.map((item, i) => {
          return (
            <ItemStyled key={i}>
              <ItemImageStyled
                src={
                  require('../../assets/images/games/' + item.images[0]).default
                }
                alt='Game image'
              />
              <ItemBlockStyled>
                <div>
                  <ItemPlayerStyled src={activePlayer} alt='Active player' />
                  <ItemPlayerStyled
                    src={item.players > 1 ? activePlayer : unactivePlayer}
                    alt='Status player'
                  />
                  <ItemPlayerStyled
                    src={item.players > 2 ? activePlayer : unactivePlayer}
                    alt='Status player'
                  />
                  <ItemPlayerStyled
                    src={item.players > 3 ? activePlayer : unactivePlayer}
                    alt='Status player'
                  />
                </div>
                <ItemTitleStyled>{item.title}</ItemTitleStyled>
                <ItemDescriptionStyled>
                  {item.description[context.language]}
                </ItemDescriptionStyled>
              </ItemBlockStyled>
            </ItemStyled>
          )
        })}
      </Slider>
      {!isBirthday && (
        <ButtonStyled
          title={fullGameListText}
          variant='solid'
          defaultSize
          onClick={() => navigate(`/${city.slug}/games`)}
        />
      )}
    </ContainerLayoutStyled>
  )
}
export default Games

const ContainerLayoutStyled = styled(ContainerLayout)`
  &:before {
    content: '';
    width: 110px;
    height: 70px;

    position: absolute;
    left: 20%;
    top: 40px;

    background-image: url(${fallingStar});
    background-size: 95%;
    background-repeat: no-repeat;
  }
  &:after {
    content: '';
    width: 170px;
    height: 28px;

    position: absolute;
    right: 10%;
    top: 15%;

    background-image: url(${slashedGreyCubes});
    background-size: 80%;
    background-repeat: no-repeat;
  }
  .slick-dots {
    display: flex !important;
    align-items: center;
    justify-content: center;

    width: 100%;
    margin: 0;

    bottom: -100px;

    list-style: none;
    text-align: center;
    z-index: 1;
  }
  .slick-dots li {
    display: flex;

    margin: 0 5px;
    padding: 0;

    position: relative;
    cursor: pointer;
  }
  .slick-dots li span {
    height: 25px;
    width: 5px;

    background-color: rgba(255, 255, 255, 0.2);
  }
  .slick-dots li.slick-active span,
  .slick-dots li:hover span {
    background-color: ${(props) => props.theme.colors.green};
    transition: 0.3s ease-in-out;
  }

  @media ${(props) => props.theme.breakpoints.laptop} {
    .slick-list {
      margin: 0;
    }
  }
  @media ${(props) => props.theme.breakpoints.tablet} {
    &:after {
      display: none;
    }
    &:before {
      top: 20px;
      left: 10%;

      background-size: 80%;
    }
    .slick-dots {
      bottom: -50px;
    }
  }
`

const TitleStyled = styled.p`
  margin-bottom: 5.5rem;

  font-size: 2.5rem;
  line-height: 1.14;
  text-align: center;
  color: ${(props) => props.theme.colors.white};
  z-index: 1;

  br {
    display: none;
  }

  @media ${(props) => props.theme.breakpoints.small} {
    margin-bottom: 2.5rem;

    font-size: 1.7rem;
    br {
      display: block;
    }
  }
`

const ItemBlockStyled = styled.div`
  margin-bottom: 140px;
  transform: translateY(100%);
  padding: 0 35px 20px;

  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;

  overflow: hidden;
  transition: 0.3s ease-in-out;

  @media ${(props) => props.theme.breakpoints.medium} {
    padding: 0 20px 20px;
    margin-bottom: 120px;
  }
`

const ItemStyled = styled.div`
  position: relative;

  border-radius: 9px;
  overflow: hidden;
  cursor: pointer;

  &:after {
    content: '';
    height: 100%;
    width: 100%;

    position: absolute;
    top: 0;
    opacity: 0;
    z-index: 1;

    background-color: ${(props) => props.theme.colors.black};
    transition: 0.3s ease-in-out;
  }

  &:hover:after {
    opacity: 0.5;
  }

  &:hover ${ItemBlockStyled} {
    margin-bottom: 0;
    transform: translateY(0%);
  }
`

const ItemImageStyled = styled.img`
  display: block;

  width: 100%;
  height: 460px;

  border-radius: 9px;

  @media ${(props) => props.theme.breakpoints.desktop} {
    height: 380px;
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    height: 300px;
  }
`

const ItemTitleStyled = styled.span`
  display: block;

  margin: 1rem 0 1.5rem;

  font-size: 1.4rem;
  font-family: ${(props) => props.theme.fonts.futuraDemi};

  @media ${(props) => props.theme.breakpoints.medium} {
    margin: 0.5rem 0 1rem;

    font-size: 1.2rem;
  }
`
const ItemDescriptionStyled = styled.p`
  font-size: 1rem;
  line-height: 1.2;
`
const ItemPlayerStyled = styled.img`
  height: 62px;
  width: 28px;
  margin-right: 5px;

  object-fit: contain;
  @media ${(props) => props.theme.breakpoints.medium} {
    height: 56px;
    width: 20px;
    margin-right: 2px;
  }
`
const ButtonStyled = styled(Button)`
  margin: 8.5rem auto -5rem;
  @media ${(props) => props.theme.breakpoints.tablet} {
    margin: 5rem auto -2rem;
  }
`
